import styled from 'styled-components';

export const StyledContainerActivityFile = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	height: 100%;
	padding: 0px 5px;
	margin-top: 20px;
`;

export const StyledRowFile = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	font-size: 13.5px;
	font-weight: 500;
`;

export const StyledRowPrimaryFile = styled(StyledRowFile)`
	color: ${({ theme }) => theme.colors.primary};
	margin-bottom: 10px;
`;

export const StyledText = styled.div`
	width: 100%;
	text-align: center;
`;

export const StyledInfo = styled.div`
	width: 100%;
	text-align: center;
	font-size: 12px;
`;

export const StyledRowPrimaryText = styled(StyledRowFile)`
	color: ${({ theme }) => theme.colors.primary};
	display: block;
	margin-bottom: 10px;
`;
